import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaLeaf, FaShieldAlt, FaMoneyBillWave, FaArrowRight, FaCommentAlt, FaCheckCircle, FaInfoCircle, FaCarSide, FaCar, FaTruckMonster } from 'react-icons/fa';
import './NettoyageVoiturePage.css';
import luxe1 from '../assets/interieur-luxe/interieur-luxe1.jpg';
import luxe2 from '../assets/interieur-luxe/interieur-luxe2.jpg';
import luxe3 from '../assets/interieur-luxe/interieur-luxe3.jpg';
import luxe4 from '../assets/interieur-luxe/interieur-luxe4.jpg';
import luxe5 from '../assets/interieur-luxe/interieur-luxe5.jpg';

// Banner image
const HERO_IMG = luxe4;

const CATEGORIES = [
    { id: 'compact', name: 'Citadines', icon: <FaCarSide />, label: 'Compactes' },
    { id: 'sedan', name: 'Berlines', icon: <FaCar />, label: 'SUV Compacts' },
    { id: 'suv', name: 'SUV & XL', icon: <FaTruckMonster />, label: 'Gros Volumes' }
];

const FORMULAS = {
    compact: [
        { name: "PROPRETÉ STANDARD", price: 50, subtitle: "Idéal pour un entretien régulier", features: ["Aspiration habitacle & coffre", "Nettoyage tableau de bord", "Nettoyage plastiques", "Vitrages intérieurs", "Désinfection vapeur", "Parfum d'ambiance"], img: luxe1 },
        { name: "PROPRETÉ PREMIUM", price: 70, subtitle: "Nettoyage en profondeur", featured: true, features: ["Pack Standard inclus", "Nettoyage sièges cuir/tissu", "Pressing tapis & moquettes", "Nettoyage des recoins", "Shampoing des plastiques", "Traitement anti-odeurs"], img: luxe2 },
        { name: "PROPRETÉ PRESTIGE", price: 100, subtitle: "Le soin ultime & exhaustif", features: ["Pack Premium inclus", "Protection plastiques UV", "Traitement complet cuirs", "Nettoyage ciel de toit", "Bords de portes & coffre", "Compartiment roue de secours"], img: luxe3 }
    ],
    sedan: [
        { name: "PROPRETÉ STANDARD", price: 60, subtitle: "Idéal pour un entretien régulier", features: ["Aspiration habitacle & coffre", "Nettoyage tableau de bord", "Nettoyage plastiques", "Vitrages intérieurs", "Désinfection vapeur", "Parfum d'ambiance"], img: luxe1 },
        { name: "PROPRETÉ PREMIUM", price: 80, subtitle: "Nettoyage en profondeur", featured: true, features: ["Pack Standard inclus", "Nettoyage sièges cuir/tissu", "Pressing tapis & moquettes", "Nettoyage des recoins", "Shampoing des plastiques", "Traitement anti-odeurs"], img: luxe2 },
        { name: "PROPRETÉ PRESTIGE", price: 110, subtitle: "Le soin ultime & exhaustif", features: ["Pack Premium inclus", "Protection plastiques UV", "Traitement complet cuirs", "Nettoyage ciel de toit", "Bords de portes & coffre", "Compartiment roue de secours"], img: luxe3 }
    ],
    suv: [
        { name: "PROPRETÉ STANDARD", price: 70, subtitle: "Idéal pour un entretien régulier", features: ["Aspiration habitacle & coffre", "Nettoyage tableau de bord", "Nettoyage plastiques", "Vitrages intérieurs", "Désinfection vapeur", "Parfum d'ambiance"], img: luxe1 },
        { name: "PROPRETÉ PREMIUM", price: 90, subtitle: "Nettoyage en profondeur", featured: true, features: ["Pack Standard inclus", "Nettoyage sièges cuir/tissu", "Pressing tapis & moquettes", "Nettoyage des recoins", "Shampoing des plastiques", "Traitement anti-odeurs"], img: luxe2 },
        { name: "PROPRETÉ PRESTIGE", price: 120, subtitle: "Le soin ultime & exhaustif", features: ["Pack Premium inclus", "Protection plastiques UV", "Traitement complet cuirs", "Nettoyage ciel de toit", "Bords de portes & coffre", "Compartiment roue de secours"], img: luxe3 }
    ]
};

const NettoyageVoiturePage = () => {
    const [selectedCat, setSelectedCat] = useState('compact');

    return (
        <div className="voiture-page-wrapper">

            {/* Smart Selector Section */}
            <section className="selection-trigger-section">
                <div className="container">
                    <motion.div className="selector-header center">
                        <span className="premium-label">ÉTAPE 1 : CHOISISSEZ VOTRE VÉHICULE</span>
                        <h2 className="section-title">Quel est votre <span className="text-gradient-blue">modèle ?</span></h2>
                    </motion.div>

                    <div className="type-selector-grid">
                        {CATEGORIES.map((cat) => (
                            <button
                                key={cat.id}
                                className={`type-card ${selectedCat === cat.id ? 'active' : ''}`}
                                onClick={() => setSelectedCat(cat.id)}
                            >
                                <div className="type-icon">{cat.icon}</div>
                                <div className="type-info">
                                    <span className="type-name">{cat.name}</span>
                                    <span className="type-label">{cat.label}</span>
                                </div>
                                {selectedCat === cat.id && <motion.div layoutId="active-bg" className="active-glow" />}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Pricing Matrix Section */}
            <section className="pricing-matrix-section">
                <div className="container">
                    <div className="pricing-grid-premium">
                        <AnimatePresence mode="wait">
                            {FORMULAS[selectedCat].map((formula, idx) => (
                                <motion.div
                                    key={`${selectedCat}-${formula.name}`}
                                    className={`pricing-card-premium ${formula.featured ? 'featured' : ''}`}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.4, delay: idx * 0.1 }}
                                >
                                    <div className="pricing-card-img-wrapper">
                                        <img src={formula.img} alt={formula.name} />
                                        <div className="card-badge">{formula.name}</div>
                                        <div className="card-overlay"></div>
                                    </div>
                                    <div className="pricing-card-content">
                                        <div className="category-tag">{formula.subtitle}</div>
                                        <ul className="formula-features">
                                            {formula.features.map((feat, i) => (
                                                <li key={i}><FaCheckCircle className="check-icon" /> {feat}</li>
                                            ))}
                                        </ul>
                                        <div className="pricing-footer">
                                            <div className="price-info">
                                                <span className="price-from">dès</span>
                                                <span className="price-value">{formula.price}€</span>
                                            </div>
                                            <Link 
                                                to="/reservation" 
                                                state={{ 
                                                    category: 'voiture', 
                                                    type: selectedCat === 'compact' ? 'Citadine' : (selectedCat === 'berline' ? 'Berline' : 'SUV / Monospace'),
                                                    prestation: `${formula.name} - ${selectedCat === 'compact' ? 'Citadine' : (selectedCat === 'berline' ? 'Berline' : 'SUV / Monospace')}`
                                                }}
                                                className="btn-premium-small"
                                            >
                                                RÉSERVER <FaArrowRight />
                                            </Link>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                </div>
            </section>

            {/* Information Notes */}
            <section className="station-footer-notes-premium">
                <div className="container">
                    <motion.div className="notes-container-premium">
                        <div className="notes-header-premium">
                            <FaInfoCircle className="info-icon-premium" />
                            <span>Conditions Tarifaires</span>
                        </div>
                        <div className="notes-body-premium">
                            <p>Les tarifs indiqués sont des prix de base susceptibles de varier selon l'état réel de votre véhicule.</p>
                            <div className="premium-alert-box">
                                <strong>* Supplément de 15€ à 30€ :</strong> poils d'animaux, présence de sable excessive, terre ou véhicule particulièrement sale.
                            </div>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* Why Choose Us Section */}
            <section className="voiture-benefits-section-premium">
                <div className="container">
                    <motion.div className="section-header center">
                        <span className="premium-label">L'EXPERTISE RP</span>
                        <h2 className="section-title">Un service <span className="text-gradient-blue">sans compromis</span></h2>
                    </motion.div>

                    <div className="benefits-grid-premium">
                        <div className="benefit-card-premium">
                            <div className="benefit-icon-wrapper green"><FaLeaf /><div className="icon-glow"></div></div>
                            <h3>97% Éco-Responsable</h3>
                            <p>Utilisation de produits biosourcés pour préserver l'environnement et votre habitacle.</p>
                        </div>
                        <div className="benefit-card-premium">
                            <div className="benefit-icon-wrapper blue"><FaShieldAlt /><div className="icon-glow"></div></div>
                            <h3>Désinfection Vapeur</h3>
                            <p>Élimination radicale des bactéries et allergènes sans produits chimiques agressifs.</p>
                        </div>
                        <div className="benefit-card-premium">
                            <div className="benefit-icon-wrapper gold"><FaMoneyBillWave /><div className="icon-glow"></div></div>
                            <h3>Valeur Maximisée</h3>
                            <p>Un entretien professionnel pour maintenir la cote de revente de votre véhicule.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer CTA */}
            <section className="voiture-footer-cta-premium">
                <div className="container">
                    <div className="cta-card-premium has-accent">
                        <div className="cta-glow-effect"></div>
                        <div className="cta-content-wrapper">
                            <div className="cta-left">
                                <div className="cta-icon-box-premium"><FaCommentAlt /></div>
                                <div className="cta-text-content-premium">
                                    <h3>Besoin d'un conseil ?</h3>
                                    <p>Contactez-moi directement pour une étude personnalisée de votre projet.</p>
                                </div>
                            </div>
                            <div className="cta-right">
                                <Link to="/contact" className="btn-cta-premium">ME CONTACTER <FaArrowRight /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NettoyageVoiturePage;
